import type { AnimationItem, AnimationSegment } from 'lottie-web';

export interface PlayLottieAnimationParams {
  readonly lottieItem: AnimationItem | undefined;
  readonly segments: AnimationSegment;
  readonly loop?: boolean;
}

export const playLottieAnimation = ({ lottieItem, segments, loop }: PlayLottieAnimationParams): void => {
  if (lottieItem == null) return;
  if (loop != null) lottieItem.setLoop(loop);

  lottieItem.playSegments(segments, true);
};
